export const fieldLabels = {
  type: "Type",
  title: "Title",
  subHeading: "Sub-heading",
  excerpt: "Excerpt",
  content: "Content",
  publishedDate: "Published date",
  resourceTags: "Tag(s)",
  videoEmbed: "Video Embed",
}